import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import IvergramaTitle from '../../Ivergrama/common/IvergramaTitle';
import KuposHelmet from '../../../common/KuposHelmet';
import OfficesList from '../../common/OfficeList/OfficesList';
import OfficesList4 from '../../common/OfficeList/OfficesList4';
import React from 'react';
import ThemeNineTitle from '../common/ThemeNineTitle';
import ThemeTwoOfficeSection from '../../ThemeTwo/common/ThemeTwoOfficeSection';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const operator = CommonService.getLocal('op');
const ThemeNineOfficeScreen = props => {

	const title = operator.operator_name === 'arzola' ? 'Sucursales' : 'Oficinas';
	const description = operator.operator_name === 'arzola' ? 'Home / Sucursales' : 'Home / Oficinas';



	// const operator = props.home && props.home.operator;
	console.log("operator in themenneoffices", operator)
	return (
		<div className="themes-theme-nine-office-screen ">
			<KuposHelmet />
			<div style={{ position: 'relative', marginTop: operator && operator.operator_name === 'arzola' ? 0 : -130, }}>
				<HeroSection
					// height={'30vh'}
					heroImage={getIcons('officeBanner')}
					title={title}
					description={description}
				/>
			</div>

			{operator.operator_name === 'arzola' ? (
				<IvergramaTitle operator={operator} title={<strong>Sucursales</strong>} />
			) : (
				<ThemeNineTitle title={'¡Conoce nuestras oficinas!'} />
			)}

			<OfficesList4
				operator={operator}
			/>

		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

export default connect(mapStateToProps, {})(ThemeNineOfficeScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeNine/ThemeNinePages/ThemeNineOfficeScreen.js